export default __webpack_public_path__ + "static/media/CL08.57adb116.mp3";